import { CropperAspectRatio } from "../interfaces/cropper-dialog.interface";

export type AspectRatio = '1:1'|'1:2'|'2:3'|'3:4'|'3:5'|'4:5'|'5:16'|'9:16';

export const aspectRatios: CropperAspectRatio[] = [
    { sizeV: 1/1,    sizeH: 1/1,   label: '1:1'   },
    { sizeV: 1/2,    sizeH: 2/1,   label: '1:2'   },
    { sizeV: 2/3,    sizeH: 3/2,   label: '2:3'   },
    { sizeV: 3/4,    sizeH: 4/3,   label: '3:4'   },
    { sizeV: 3/5,    sizeH: 5/3,   label: '3:5'   },
    { sizeV: 4/5,    sizeH: 5/4,   label: '4:5'   },
    { sizeV: 5/16,   sizeH: 16/5,  label: '5:16'  },
    { sizeV: 9/16,   sizeH: 16/9,  label: '9:16'  },
  ];